import React, { useState } from "react";
import { Row, Table, Button, Divider } from 'antd';
import {PlusOutlined} from "@ant-design/icons";
import TickerChip from "./TickerChip";

/**
 * Displays a table of tickers. Optionally, it can be displayed within a modal.
 * Users can select tickers, and the selected tickers are passed to the onSubmit callback.
 *
 * @param {Object[]} tickers - Array of objects containing ticker information.
 * @param {Function} onSubmit - Callback function to handle the submission of selected tickers.
 * @param {string} [submitText='Submit'] - Text to display on the submit button.
 */
const TickersTable = ({ tickers, onSubmit, submitText='Submit' }) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    console.log("tickers", tickers)
    // Handler for selecting rows
    const onSelectChange = (newSelectedRowKeys, newSelectedRows) => {
        setSelectedRowKeys(newSelectedRowKeys);
        setSelectedRows(newSelectedRows);
    };

    const handleOk = () => {
        // Pass the selected rows back to the onSubmit callback
        onSubmit(selectedRows);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const columns = [
        {
            title: "Security",
            key: "ticker",
            render: (_, record) => <TickerChip ticker={record} />,

        }
    ];

   return  (
       <>
           <Row justify={'end'}>
               <Button icon={<PlusOutlined/>} type="primary" onClick={handleOk} disabled={selectedRows.length === 0}>
                   {submitText}
               </Button>
           </Row>
           <Divider/>
           <Table
                rowSelection={rowSelection}
                columns={columns}
                dataSource={tickers}
                rowKey="symbol" // Assuming 'symbol' is unique for each ticker
            />
       </>
   )
};

export default TickersTable;
